import { Stack, Typography } from "@mui/material";
import { getSavingsPlanCommonColumns } from "./common/getSavingsPlanCommonColumns";
import { SavingsPlanCoverageDataWithId } from "../../../../../../utils/types";
import { ColumnSetupType } from "../../../../../../../../../../storybook/data-grid/utils/types/types";

export const savingsPlanGroupedByAccountColumns: ColumnSetupType<SavingsPlanCoverageDataWithId>[] =
  [
    {
      accessorKey: "account",
      header: "Account",
      cell: ({ row }) => {
        return (
          <Stack>
            <Typography variant="body2">
              {row.original.account?.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {row.original.account?.provider_account_id}
            </Typography>
          </Stack>
        );
      },
    },
    ...getSavingsPlanCommonColumns("account"),
  ];
